import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { useApp } from "@/lib/store";

/**
 * Light/dark mode switch. Shows the mode you will switch TO:
 * a sun while in dark mode, a moon while in light mode.
 */
export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useApp();
  const label = theme === "dark" ? t("Ljust läge") : t("Mörkt läge");

  return (
    <button
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      className={`theme-toggle relative p-2.5 rounded-full hover:bg-[#1A1A1A] border border-transparent hover:border-[#D4B483]/25 transition-colors group ${className}`}
    >
      <span className="relative block w-5 h-5">
        <Sun
          className={`absolute inset-0 w-5 h-5 text-[#EDEDED] group-hover:text-[#D4B483] transition-all duration-300 ${
            theme === "dark" ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-50"
          }`}
        />
        <Moon
          className={`absolute inset-0 w-5 h-5 text-[#EDEDED] group-hover:text-[#D4B483] transition-all duration-300 ${
            theme === "light" ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-50"
          }`}
        />
      </span>
    </button>
  );
}
